<template>
  <div class="tw-rounded-xl tw-border tw-border-neutral-300 tw-p-8 tw-flex tw-flex-col tw-gap-4">
    <slot />
  </div>
</template>
